"use strict";
// The order 101149 bench. The backend capture rule and the capture dialog preview both
// pin these rows, so the two sides cannot drift.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAPTURE_APPLICATION_BENCH = void 0;
const money_1 = require("./money");
const P1_ID = 'bench-p1';
const P1_REF = 'ADV-101149-1';
const P1_NUMBER = 'DP-101149';
const P2_ID = 'bench-p2';
const P2_REF = 'PROV-101149-A';
const P2_NUMBER = 'SUP-PROV-A';
const P3_ID = 'bench-p3';
const P3_REF = 'PROV-101149-B';
const P3_NUMBER = 'SUP-PROV-B';
function advanceTarget(remaining) {
    return {
        documentId: P1_ID,
        documentRef: P1_REF,
        documentNumber: P1_NUMBER,
        kind: 'advance',
        anchorBlRef: null,
        remaining: (0, money_1.toMoney)(remaining),
    };
}
function provisionalA(remaining) {
    return {
        documentId: P2_ID,
        documentRef: P2_REF,
        documentNumber: P2_NUMBER,
        kind: 'provisional',
        anchorBlRef: 'BL-A',
        remaining: (0, money_1.toMoney)(remaining),
    };
}
function provisionalB(remaining) {
    return {
        documentId: P3_ID,
        documentRef: P3_REF,
        documentNumber: P3_NUMBER,
        kind: 'provisional',
        anchorBlRef: 'BL-B',
        remaining: (0, money_1.toMoney)(remaining),
    };
}
function advanceRow(applied, remainingAfter) {
    return {
        documentId: P1_ID,
        documentRef: P1_REF,
        documentNumber: P1_NUMBER,
        kind: 'advance',
        applied: (0, money_1.toMoney)(applied),
        remainingAfter: (0, money_1.toMoney)(remainingAfter),
    };
}
function provisionalARow(applied, remainingAfter) {
    return {
        documentId: P2_ID,
        documentRef: P2_REF,
        documentNumber: P2_NUMBER,
        kind: 'provisional',
        applied: (0, money_1.toMoney)(applied),
        remainingAfter: (0, money_1.toMoney)(remainingAfter),
    };
}
function provisionalBRow(applied, remainingAfter) {
    return {
        documentId: P3_ID,
        documentRef: P3_REF,
        documentNumber: P3_NUMBER,
        kind: 'provisional',
        applied: (0, money_1.toMoney)(applied),
        remainingAfter: (0, money_1.toMoney)(remainingAfter),
    };
}
// Card 1680, the order 1003059 walk: one order-level advance of 78,720 (39,360 per BL by the
// contract), a BL1 provisional that consumed 39,360 of it and then a 440 credit, a BL1 final that
// prints a provisional line and no advance line, and a BL2 final that prints its advance line.
const P4_ID = 'bench-p4';
const P4_REF = 'PROV-1003059-1';
const P4_NUMBER = 'SR-2026-0842';
function provisionalBl1(remaining) {
    return {
        documentId: P4_ID,
        documentRef: P4_REF,
        documentNumber: P4_NUMBER,
        kind: 'provisional',
        anchorBlRef: '1003059-1',
        remaining: (0, money_1.toMoney)(remaining),
    };
}
function provisionalBl1Row(applied, remainingAfter) {
    return {
        documentId: P4_ID,
        documentRef: P4_REF,
        documentNumber: P4_NUMBER,
        kind: 'provisional',
        applied: (0, money_1.toMoney)(applied),
        remainingAfter: (0, money_1.toMoney)(remainingAfter),
    };
}
exports.CAPTURE_APPLICATION_BENCH = [
    {
        id: 'p2-printed',
        paper: { kind: 'provisional', anchorBlRef: 'BL-A' },
        gross: (0, money_1.toMoney)('47492.76'),
        printedAdvanceDeduction: (0, money_1.toMoney)('38769.60'),
        printedProvisionalDeduction: null,
        printedAmountDue: (0, money_1.toMoney)('8723.16'),
        targets: [advanceTarget('78720.00')],
        expected: {
            source: 'printed',
            rows: [advanceRow('38769.60', '39950.40')],
            applied: (0, money_1.toMoney)('38769.60'),
            net: (0, money_1.toMoney)('8723.16'),
            advanceDeduction: 'match',
            provisionalDeduction: 'not_stated',
            amountDue: 'match',
        },
    },
    {
        id: 'p2-derived',
        paper: { kind: 'provisional', anchorBlRef: 'BL-A' },
        gross: (0, money_1.toMoney)('47492.76'),
        printedAdvanceDeduction: null,
        printedProvisionalDeduction: null,
        printedAmountDue: null,
        targets: [advanceTarget('78720.00')],
        expected: {
            source: 'derived',
            rows: [advanceRow('47492.76', '31227.24')],
            applied: (0, money_1.toMoney)('47492.76'),
            net: (0, money_1.toMoney)('0.00'),
            advanceDeduction: 'not_stated',
            provisionalDeduction: 'not_stated',
            amountDue: 'not_stated',
        },
    },
    {
        id: 'p3-printed',
        paper: { kind: 'provisional', anchorBlRef: 'BL-B' },
        gross: (0, money_1.toMoney)('48838.79'),
        printedAdvanceDeduction: (0, money_1.toMoney)('39868.40'),
        printedProvisionalDeduction: null,
        printedAmountDue: (0, money_1.toMoney)('8970.39'),
        targets: [advanceTarget('39950.40'), provisionalA('47492.76')],
        expected: {
            source: 'printed',
            rows: [advanceRow('39868.40', '82.00')],
            applied: (0, money_1.toMoney)('39868.40'),
            net: (0, money_1.toMoney)('8970.39'),
            advanceDeduction: 'match',
            provisionalDeduction: 'not_stated',
            amountDue: 'match',
        },
    },
    {
        id: 'p3-cap',
        paper: { kind: 'provisional', anchorBlRef: 'BL-B' },
        gross: (0, money_1.toMoney)('48838.79'),
        printedAdvanceDeduction: (0, money_1.toMoney)('50000.00'),
        printedProvisionalDeduction: null,
        printedAmountDue: null,
        targets: [advanceTarget('39950.40'), provisionalA('47492.76')],
        expected: {
            source: 'printed',
            rows: [advanceRow('39950.40', '0.00')],
            applied: (0, money_1.toMoney)('39950.40'),
            net: (0, money_1.toMoney)('8888.39'),
            advanceDeduction: 'mismatch',
            provisionalDeduction: 'not_stated',
            amountDue: 'not_stated',
        },
    },
    {
        id: 'p5-final',
        paper: { kind: 'final', anchorBlRef: 'BL-A' },
        gross: (0, money_1.toMoney)('47251.68'),
        printedAdvanceDeduction: (0, money_1.toMoney)('47251.68'),
        printedProvisionalDeduction: null,
        printedAmountDue: (0, money_1.toMoney)('0.00'),
        targets: [advanceTarget('82.00'), provisionalA('47251.68'), provisionalB('48838.79')],
        expected: {
            source: 'printed',
            rows: [advanceRow('82.00', '0.00'), provisionalARow('47169.68', '82.00')],
            applied: (0, money_1.toMoney)('47251.68'),
            net: (0, money_1.toMoney)('0.00'),
            advanceDeduction: 'match',
            provisionalDeduction: 'not_stated',
            amountDue: 'match',
        },
    },
    {
        id: 'p6-final',
        paper: { kind: 'final', anchorBlRef: 'BL-B' },
        gross: (0, money_1.toMoney)('48838.79'),
        printedAdvanceDeduction: (0, money_1.toMoney)('48838.79'),
        printedProvisionalDeduction: null,
        printedAmountDue: (0, money_1.toMoney)('0.00'),
        targets: [advanceTarget('0.00'), provisionalA('82.00'), provisionalB('48838.79')],
        expected: {
            source: 'printed',
            rows: [provisionalBRow('48838.79', '0.00')],
            applied: (0, money_1.toMoney)('48838.79'),
            net: (0, money_1.toMoney)('0.00'),
            advanceDeduction: 'match',
            provisionalDeduction: 'not_stated',
            amountDue: 'match',
        },
    },
    {
        id: 'bl1-final-provisional-line',
        paper: { kind: 'final', anchorBlRef: '1003059-1' },
        gross: (0, money_1.toMoney)('50315.20'),
        printedAdvanceDeduction: null,
        printedProvisionalDeduction: (0, money_1.toMoney)('49940.80'),
        printedAmountDue: (0, money_1.toMoney)('374.40'),
        targets: [advanceTarget('39360.00'), provisionalBl1('49940.80')],
        expected: {
            source: 'printed',
            rows: [provisionalBl1Row('49940.80', '0.00')],
            applied: (0, money_1.toMoney)('49940.80'),
            net: (0, money_1.toMoney)('374.40'),
            advanceDeduction: 'not_stated',
            provisionalDeduction: 'match',
            amountDue: 'match',
        },
    },
    {
        id: 'bl1-final-zero-advance-line',
        paper: { kind: 'final', anchorBlRef: '1003059-1' },
        gross: (0, money_1.toMoney)('50315.20'),
        printedAdvanceDeduction: (0, money_1.toMoney)('0.00'),
        printedProvisionalDeduction: (0, money_1.toMoney)('49940.80'),
        printedAmountDue: (0, money_1.toMoney)('374.40'),
        targets: [advanceTarget('39360.00'), provisionalBl1('49940.80')],
        expected: {
            source: 'printed',
            rows: [provisionalBl1Row('49940.80', '0.00')],
            applied: (0, money_1.toMoney)('49940.80'),
            net: (0, money_1.toMoney)('374.40'),
            advanceDeduction: 'match',
            provisionalDeduction: 'match',
            amountDue: 'match',
        },
    },
    {
        id: 'bl2-final-advance-line',
        paper: { kind: 'final', anchorBlRef: '1003059-2' },
        gross: (0, money_1.toMoney)('51168.00'),
        printedAdvanceDeduction: (0, money_1.toMoney)('39360.00'),
        printedProvisionalDeduction: null,
        printedAmountDue: (0, money_1.toMoney)('11808.00'),
        targets: [advanceTarget('39360.00'), provisionalBl1('0.00')],
        expected: {
            source: 'printed',
            rows: [advanceRow('39360.00', '0.00')],
            applied: (0, money_1.toMoney)('39360.00'),
            net: (0, money_1.toMoney)('11808.00'),
            advanceDeduction: 'match',
            provisionalDeduction: 'not_stated',
            amountDue: 'match',
        },
    },
    {
        id: 'bl1-final-provisional-over',
        paper: { kind: 'final', anchorBlRef: '1003059-1' },
        gross: (0, money_1.toMoney)('50315.20'),
        printedAdvanceDeduction: null,
        printedProvisionalDeduction: (0, money_1.toMoney)('60000.00'),
        printedAmountDue: null,
        targets: [advanceTarget('39360.00'), provisionalBl1('49940.80')],
        expected: {
            source: 'printed',
            rows: [provisionalBl1Row('49940.80', '0.00')],
            applied: (0, money_1.toMoney)('49940.80'),
            net: (0, money_1.toMoney)('374.40'),
            advanceDeduction: 'not_stated',
            provisionalDeduction: 'mismatch',
            amountDue: 'not_stated',
        },
    },
];
//# sourceMappingURL=capture-application-bench.js.map